/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _isSelected = _interopRequireDefault(require("./isSelected"));
function filterByValue(_ref) {
  var data = _ref.data,
    getIdProperty = _ref.getIdProperty,
    value = _ref.value;
  return data.filter(function (item) {
    var id = getIdProperty(item);
    return !(0, _isSelected.default)({
      id: id,
      value: value
    });
  });
}
var _default = filterByValue;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/packages/ComboBox/src/utils/filterByValue.js
// module id = 659
// module chunks = 0